// components/toolbar/DownloadMenu.tsx
import { Dropdown, Menu, MenuButton, MenuItem } from "@mui/base";
import DownloadIcon from "@mui/icons-material/Download";
import { Button, IconButton, List, styled } from "@mui/material";

interface DownloadButton {
    label: string;
    onClick: () => void;
}

const Listbox = styled(List)(({ theme }) => ({
    padding: 6,
    borderRadius: 12,
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    zIndex: 9999,
}));

const NoStyleMenuButton = styled(MenuButton)({
    background: "none",
    border: "none",
});

interface DownloadMenuProps {
    buttons: DownloadButton[];
    iconSize?: "small" | "medium";
}

const DownloadMenu = ({ buttons, iconSize = "small" }: DownloadMenuProps) => {
    if (!buttons.length) return null;

    return (
        <Dropdown>
            <NoStyleMenuButton>
                <IconButton size={iconSize}>
                    <DownloadIcon fontSize={iconSize} />
                </IconButton>
            </NoStyleMenuButton>

            <Menu slots={{ listbox: Listbox }} style={{ zIndex: 9999 }}>
                {buttons.map((btn, index) => (
                    <MenuItem key={index}>
                        <Button fullWidth onClick={btn.onClick}>
                            {btn.label}
                        </Button>
                    </MenuItem>
                ))}
            </Menu>
        </Dropdown>
    );
};

export default DownloadMenu;
